import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement> & {
  restrictedState: boolean;
};

const PriceDropArrowIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => {
  return props.restrictedState ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="55"
      viewBox="0 0 74 55"
      fill="none"
      ref={ref}
      {...props}
    >
      <path
        d="M46.4398 4.79378C52.8144 11.1683 62.9175 21.2715 69.2921 27.646M69.2921 27.646L46.4398 50.4983M69.2921 27.646L3.99996 27.646"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      ref={ref}
      {...props}
    >
      <path
        d="M50.7303 18.4123C50.7303 27.4273 50.7303 41.7153 50.7303 50.7303M50.7303 50.7303H18.4123M50.7303 50.7303L4.56177 4.56177"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default PriceDropArrowIcon;
